module.exports = __webpack_public_path__ + "media/assets/images/banner-598b724cd790cdd580aa6ce7be9bdf72.png";